import React, { useContext } from 'react'
import Heading from 'src/components/Heading';
import Button from 'src/components/Button';
import Label from 'src/components/Label';
import { PageContext } from 'src/utils/context';
import RichText from 'src/utils/RichText';
import resolveLink from 'src/utils/resolveLink'

const PricingPanel = ({pricing, features, additional_features, additional, additional_title, active, id}) => {

    const { setCtaReferrer } = useContext(PageContext)

    const handleClick = (value) => {
        setCtaReferrer(value)
    }

    return (
        <div className={`max-w-7xl mx-auto px-6 overflow-hidden 2xl:max-w-screen-2xl ${id === active ? 'visible h-auto' : 'invisible !h-0'}`}> 
            <div className={`grid grid-cols-1 duration-500 mb-3 ${id === active ? 'opacity-100' : 'opacity-0'}`}>
                <div className="rounded-md py-16 bg-grey shadow-md mt-4">
                    <Heading size="h4" className="capitalize !mb-6 xl:px-16 px-10">Govox {id}</Heading>
                    <div className="grid md:grid-cols-3 grid-cols-1 md:gap-0 gap-6">
                        {pricing.map((item) => (
                            <div className={`border-r last:border-0 border-[#E1E1E2] xl:px-16 px-10 flex flex-col justify-between`}>
                                <div>
                                    <h4 className="text-sm font-bold mb-1">{item.title}</h4>
                                    <div className="flex flex-row items-end mb-2">
                                        <Heading size="h3" className="text-teal !font-bold !mb-0">{item.price}</Heading>
                                        <span className="text-sm font-semibold ml-1 mb-1 prose text-blue prose-b">
                                            <RichText>{item.price_description}</RichText>
                                        </span>
                                    </div>
                                </div>
                                <Button to={resolveLink(item.button_target?.cached_url)} className="bg-blue hover:bg-darkblue md:w-full text-center md:mt-2" onClick={() => handleClick(`${item.title} - ${item.price} - ${item.price_description}`)}>{item.button_text ? item.button_text : 'Get started'}</Button>
                            </div>
                        ))}
                    </div>
                </div>
                <div className="mt-4 rounded-md xl:px-16 px-10 py-16 bg-grey shadow-md">
                    <Label className="text-teal text-[13px] !mb-0 flex flex-row items-center">
                        <span>Included features</span>
                        <span className="h-px flex-1 bg-[#E1E1E2] ml-3"></span>
                    </Label>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-3 mt-6">
                        {features?.map((item) => (
                            <div className="flex flex-row items-center prose text-sm">
                                <i className="fa-solid fa-check text-teal mr-2"></i>
                                {item.title}
                            </div>
                        ))}
                    </div>
                </div>
                { additional_features &&
                <div className="mt-4 rounded-md xl:px-16 px-10 py-16 bg-grey shadow-md">
                    <Label className="text-teal text-[13px] !mb-0 flex flex-row items-center">
                        <span>Additonal features available (extra cost)</span>
                        <span className="h-px flex-1 bg-[#E1E1E2] ml-3"></span>
                    </Label>
                    <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-x-8 gap-y-3 mt-6">
                        {additional_features?.map((item) => (
                            <div className="flex flex-row items-center prose text-sm">
                                <i className="fa-solid fa-check text-teal mr-2"></i>
                                {item.title}
                            </div>
                        ))}
                    </div>
                </div> }
                {additional &&
                <div className="rounded-md py-16 bg-grey shadow-md mt-4">
                    <Heading size="h4" className="capitalize !mb-6 xl:px-16 px-10">{additional_title}</Heading>
                    <div className="grid md:grid-cols-3 grid-cols-1 md:gap-0 gap-6">
                        {additional.map((item) => (
                            <div className={`border-r last:border-0 border-[#E1E1E2] xl:px-16 px-10 flex flex-col justify-between`}>
                                <div>
                                    <h4 className="text-sm font-bold mb-1">{item.title}</h4>
                                    <div className="flex flex-row items-end mb-2">
                                        <Heading size="h3" className="text-teal !font-bold !mb-0">{item.price}</Heading>
                                        <span className="text-sm font-semibold ml-1 mb-1 prose text-blue prose-b">
                                            <RichText>{item.price_description}</RichText>
                                        </span>
                                    </div>
                                </div>
                                <Button to={resolveLink(item.button_target?.cached_url)} className="bg-blue hover:bg-darkblue md:w-full text-center md:mt-2" onClick={() => handleClick(`${item.title} - ${item.price} - ${item.price_description}`)}>{item.button_text ? item.button_text : 'Get started'}</Button>
                            </div>
                        ))}
                    </div>
                </div>
                }
            </div>    
        </div>
    )
}

export default PricingPanel